import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import { Icon, Segment, Item, Grid, Image } from "semantic-ui-react";
import { styles, styles1, stylesicon, stylesiconred } from "./element";
import { ImageItem, WhiteTitle, Paginate } from "../../components";
import millify from "millify";

var humanFormat = require("human-format");

const CardList = ({
  cardData,
  href,
  save,
  homedata,
  heart,
  active,
  prev,
  getData,
  checkIfImageExistshome,
  ...props
}) => {
  let data = cardData.length;
  let page_size = 3;
  let indexdata = (active - 1) * page_size;
  let homedatas = homedata.length;

  return (
    <div>
      {homedatas > 0 &&
        homedata
          .slice(indexdata)
          .slice(0, page_size)
          .map((item, index) => {
            let finaladd;
            let finaladdsec;
            let bathtotal;
            if (item.UnparsedAddress) {
              // let add = item.UnparsedAddress.split(",");

              // if (add.length > 3) {
              //   finaladd = add[2];
              //   finaladdsec = add[0] + ", " + add[1] + " " + add[3];
              // } else {
              //   finaladd = item.UnparsedAddress;
              //   finaladdsec = "";
              // }

              finaladd =
                item.UnparsedAddress +
                ", " +
                item.City.replace(/([a-z])([A-Z])/g, "$1 $2") +
                ", " +
                item.StateOrProvince +
                ", " +
                item.PostalCode;
            }
            if (item.BathroomsHalf) {
              bathtotal = item.BathroomsFull + item.BathroomsHalf * 0.5;
            } else {
              bathtotal = item.BathroomsFull;
            }
            let price;
            if (item.MlsStatus === "Sold") {
              if (Number.isInteger(item.ClosePrice)) {
                price = "$" + humanFormat(item.ClosePrice).replace(/\s/g, "");
              } else {
                price = item.ClosePrice;
              }
            } else {
              if (Number.isInteger(item.ListPrice)) {
                price = "$" + humanFormat(item.ListPrice).replace(/\s/g, "");
              } else {
                price = item.ListPrice;
              }
            }
            let media;
            if (item.SourceId) {
              //if (checkIfImageExistshome(item.ThumbnailUrl)) {
              media = item.ThumbnailUrl;
              // } else if (
              //   checkIfImageExistshome(item.ThumbnailUrl) !== undefined
              // ) {
              //   media =
              //     process.env.NEXT_PUBLIC_CDN_ID + "static/images/homedefault.jpg";
              // }
            } else {
              if (item.Media && item.Media.length > 0) {
                let url = item.Media[0].MediaURL;
                let finaloutput = "";
                //media = url;

                //if (checkIfImageExistshome(url)) {
                media = url;
                // } else if (checkIfImageExistshome(url) !== undefined) {
                //   media =
                //     process.env.NEXT_PUBLIC_CDN_ID + "static/images/homedefault.jpg";
                // }
              } else {
                media =
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/homedefault.jpg";
              }
            }
            return (
              <div key={index} style={styles}>
                {/*<Link href={href}><a style={{cursor:'pointer'}} target="_blank"><ImageItem fluid source ={(item.homemimages !== null) ? item.homemimages : '/static/images/Neighborhood1.jpg'} onClick={(e)=>getData?getData(data):e.preventDefault}/></a></Link>
          {heart[index]?
            <span onClick={e => save(index, e)}><Icon size="big" name='heart' color="#c02e26" style={stylesicon}/></span>:
            <span onClick={e => save(index, e)}><Icon size="big" name='heart outline' style={stylesicon}/></span>         
          }
          <Segment basic  style={styles1}>
            <WhiteTitle icon="home" head={data.head} subhead={data.subhead} 
              desc={data.description} 
              floated="left" />
            <WhiteTitle head="1,319" subhead="Sq.Ft" floated="right" style={{borderRight:"1px solid white"}}/>
            <WhiteTitle head="2" subhead="Baths" floated="right" style={{textAlign:'center'}} />
            <WhiteTitle head="3" subhead="Beds" floated="right" style={{textAlign:'center'}} />
          </Segment>*/}
                <Item key={index}>
                  <Item.Content>
                    <Item.Description>
                      <div className="ui fluid image">
                        <Link
                          href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
                          title={item.ListingKeyNumeric}
                          style={{ cursor: "pointor" }}
                          target="_blank"
                        >
                          {/* <a style={{ cursor: "pointor" }} target="_blank"> */}
                          <img
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                process.env.NEXT_PUBLIC_CDN_ID +
                                "static/images/homedefault.jpg";
                            }}
                            style={{ height: "300px" }}
                            src={media}
                            alt={finaladd}
                            title={finaladd}
                          />
                          {/* </a> */}
                        </Link>
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            width: "100%",
                            height: "auto",
                            color: "white",
                          }}
                          className="home_list"
                        >
                          <Link
                            href={
                              "/DetailsListing/?id=" + item.ListingKeyNumeric
                            }
                            title={item.ListingKeyNumeric}
                            target="_blank"
                            style={{ color: "#FFF" }}
                          >
                            {/* <a target="_blank" style={{ color: "#FFF" }}> */}
                            <Grid style={{ padding: 10 }}>
                              <Grid.Column
                                width={7}
                                style={{
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                }}
                              >
                                <Grid.Row>
                                  <span className="home_price_main">
                                    <strong>{price}</strong>
                                  </span>
                                </Grid.Row>
                                <Grid.Row className="for_mob_add">
                                  {finaladd}
                                  <br />
                                  {finaladdsec}
                                </Grid.Row>
                                {/*<Grid.Row>{item.address.city}, {item.address.state} {item.address.zip}</Grid.Row>*/}
                              </Grid.Column>
                              <Grid.Column
                                width={9}
                                style={{
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                }}
                              >
                                <Grid
                                  divided
                                  style={{ padding: 10, textAlign: "center" }}
                                >
                                  <Grid.Column width={5}>
                                    <Grid.Row>
                                      {item.BedroomsTotal
                                        ? item.BedroomsTotal
                                        : "-"}
                                    </Grid.Row>
                                    <Grid.Row>Beds</Grid.Row>
                                  </Grid.Column>
                                  <Grid.Column width={5}>
                                    <Grid.Row>
                                      {bathtotal ? bathtotal : "-"}
                                    </Grid.Row>
                                    <Grid.Row>Baths</Grid.Row>
                                  </Grid.Column>
                                  <Grid.Column width={6}>
                                    <Grid.Row>
                                      {item.LivingArea ? item.LivingArea : "-"}
                                    </Grid.Row>
                                    <Grid.Row>sq.ft.</Grid.Row>
                                  </Grid.Column>
                                </Grid>
                              </Grid.Column>
                            </Grid>
                            {/* </a> */}
                          </Link>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            width: "100%",
                            height: "auto",
                          }}
                        >
                          <Grid style={{ padding: 10 }}>
                            <Grid.Column width={9}>
                              {/*<Grid.Row style={{backgroundColor: 'green', textAlign: 'center', color: 'white'}}>Open SUN 1PM to*/}
                              {/*4 PM</Grid.Row>*/}
                            </Grid.Column>

                            <Grid.Column floated="right" width={3}>
                              <Grid.Row>
                                {heart[item.ListingKeyNumeric] ? (
                                  <span
                                    onClick={(e) =>
                                      save(item.ListingKeyNumeric, item)
                                    }
                                  >
                                    <Icon
                                      size="big"
                                      name="heart"
                                      //color="#c02e26"
                                      style={stylesiconred}
                                    />
                                  </span>
                                ) : (
                                  <span
                                    onClick={(e) =>
                                      save(item.ListingKeyNumeric, item)
                                    }
                                  >
                                    <Icon
                                      size="big"
                                      name="heart outline"
                                      style={stylesicon}
                                    />
                                  </span>
                                )}
                              </Grid.Row>
                            </Grid.Column>
                          </Grid>
                        </div>
                      </div>
                    </Item.Description>
                  </Item.Content>
                </Item>
              </div>
            );
          })}
      {homedatas > 0 && (
        <Paginate length={homedatas} prev={prev} active={active} {...props} />
      )}
    </div>
  );
};
CardList.propTypes = {
  cardData: PropTypes.array.isRequired,
};

export default CardList;
